import React, { Component } from 'react'
import axios from "axios";
import { BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import { AiOutlineReload, AiOutlineSearch, AiOutlineBarChart } from "react-icons/ai";
import '../../css/dashboard.css'
import { getValueCookie } from '../../services/cookieService';
import { getInformationWithData } from '../../services/CABE';
import { DeleteCharactersNotAccepted, ItemDesc, MonthInLetters, NumberFormat, OrderArray } from '../../functions/generalFunctions';
import { getIndexElement } from '../../functions/searchInObject'
import { pricesFormat } from '../../functions/pricesFormat';
import { v4 as uuidv4 } from 'uuid';
import LoadingWindow from '../../components/LoadingWindow';
import ExcelDocument from '../../components/ExcelDocument';
import { getDataSet } from '../../functions/generateDataSetExcel';
import ModalOrders from '../../components/ModalComponent';
import { DateFormatMAS90, getDateFromReports, OrderArrayByDateGenericLines } from '../../functions/dateFormat';
import { confirmCloseAlert } from '../../functions/alerts';
import server from '../../services/Connection/backEndLink';
import { Menu } from "../../components/Menu/Menu";

export default class SalesCommissionReport extends Component {
    constructor(props) {
        super(props)
        this.BarGraph1 = React.createRef()
        this.ModalLoading = React.createRef();
    }

    state = {
        HeaderTable: {
            Row1: [],
            Row2: [],
            Row3: []
        },
        HeaderTable2: {
            Row1: [],
            Row2: [],
            Row3: []
        },
        BodyCustomer: [],
        BodyFilterCustomer: [],
        Body: [],
        BodyFilter: [],
        AllInformation: [],
        Totals: [],
        showModal1: false,
        currentItem: {
            ItemCode: '',
            ItemCodeDesc: '',
            ProductLine: '',
            itemURL: '',
            totalShorts: 0,
            totalQuantityShipped: 0,
            totalQuantityOrdered: 0,
            totalShort: 0
        },
        currentCustomer: {
            CustomerNo: '',
            CustomerName: '',
            totalShorts: 0,
            totalQuantityShipped: 0,
            totalQuantityOrdered: 0,
            totalShort: 0
        },
        AllNoProccessInformation: [],
        ShortDetail: [],
        CustomerDetail: [],
        ShortDetailWithTotal: [],
        flag: true,
        Mode: 1,
        CustomerList: [],

        // New Variables
        year: new Date().getFullYear(),
        week: 1,
        loading: false,
        reportData: null,
        activeTab: 'totals',
        cashReceipts: [],
        sellerList:[],
        itemCostList: [],
        InvoiceItems: [],
        qualifiedItems: [],
        allInvoiceItems: [],
        allTotals: {}
    }

    componentDidMount(){
        // this.getItemList();
    }

    // Function to retrieve the invoice w/detail between the week
    async getItemList() {
        const data = {
            idcompany: "3"
        }
        try {
            let response = await getInformationWithData('/Items/get', data);
            const responseWCommission = response.data.map(r => ({
                ...r,
                MinForCommission: (r.LastTotalUnitCost / 0.95)
            }))
            this.setState({itemCostList: responseWCommission})
        } catch (error) {
            console.log(error)
        }
    }


    TableHeader(splitStartDate, splitEndDate) {
        let years = [{ year: '', span: 4 }]
        let years2 = [{ year: '', span: 7 }]
        let months = []
        let General = [{ year: '', month: '', title: ['   No   ', 'Item Code', 'Product Line', 'Description'] }]
        let General2 = [{ year: '', month: '', title: ['   No   ', 'Customer No', 'Customer Name', 'Address', 'City', 'State', 'Zip Code'] }]

        for (let a = Number(splitStartDate[0]); a <= Number(splitEndDate[0]); a++) {
            if (a === Number(splitStartDate[0]) && a === Number(splitEndDate[0])) {
                var cont1 = 0
                for (let b = Number(splitStartDate[1]); b <= Number(splitEndDate[1]); b++) {
                    cont1++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])

                }
                const temp = {
                    year: String(a),
                    span: cont1 * 3
                }
                years.push(temp)
                years2.push(temp)
                break
            } else if (a === Number(splitStartDate[0])) {
                var cont2 = 0
                for (let b = Number(splitStartDate[1]); b <= 12; b++) {
                    cont2++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])

                }

                const temp = {
                    year: String(a),
                    span: cont2 * 3
                }
                years.push(temp)
                years2.push(temp)

            } else if (a === Number(splitEndDate[0])) {
                var cont3 = 0
                for (let b = 1; b <= Number(splitEndDate[1]); b++) {
                    cont3++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])

                }

                const temp = {
                    year: String(a),
                    span: cont3 * 3
                }
                years.push(temp)
                years2.push(temp)

            } else {

                for (let b = 1; b <= 12; b++) {

                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])

                }

                const temp = {
                    year: String(a),
                    span: 12 * 3
                }
                years.push(temp)
                years2.push(temp)
            }

        }

        this.setState({
            HeaderTable: {
                Row1: years,
                Row2: months,
                Row3: General
            },
            HeaderTable2: {
                Row1: years2,
                Row2: months,
                Row3: General2
            }
        })

        return
    }

    clearAll() {
        this.setState({
            HeaderTable: {
                Row1: [],
                Row2: [],
                Row3: []
            },
            Body: [],
            BodyFilter: [],
            AllInformation: [],
            Totals: [],
            currentItem: {
                ItemCode: '',
                ItemCodeDesc: '',
                ProductLine: '',
                itemURL: ''
            },
            AllNoProccessInformation: [],
            ShortDetail: [],
        })
    }

    async getCustomerData() {
        let company = getValueCookie('CompanyId')
        const url = server.url

        const payload = {
            data: {
                idCompany: Number(company),
                SalespersonNo: '0000'
            }
        }

        const query = "/customer/getList";
        const customers = await axios.post(`${url}${query}`, payload).then(
            response =>  response.data.data
        ).catch(error => {
            console.log(error)
        })
        this.setState({ CustomerList: customers });
        return customers;
    }

    async addCustomerData(data) {
        const customers = await this.getCustomerData()
        const dataWCustomer = data.map(item => {
            const customer = customers.find(c => c.CustomerNo === item.CustomerNo);
            if (customer) {
                return {
                    ...item,
                    AddressLine1: customer.AddressLine1,
                    City: customer.City,
                    State: customer.State,
                    ZipCode: customer.ZipCode
                };
            }
            return item;
        });

        return dataWCustomer;
    }

    async getShorts() {
        this.ModalLoading.current.showState(true);
        this.clearAll()
        var date1 = document.getElementById('startSalesFilterDate').value
        var date2 = document.getElementById('endSalesFilterDate').value
        const splitStartDate = date1.split('-')
        const splitEndDate = date2.split('-')
        if (splitStartDate.length === 3 && splitEndDate.length === 3) {
            this.TableHeader(splitStartDate, splitEndDate)
            const data = {
                Start: date1,
                End: date2,
                idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId'))
            }
            const result = await getInformationWithData('/invoice/report/SalesV2', data)

            let temporal = []
            let customer = []
            if (result.status.code === 1) {
                const AllInformationWCustomer = await this.addCustomerData(result.data);

                this.setState({ AllInformation: AllInformationWCustomer })
                for (const item of AllInformationWCustomer) {
                    const index = getIndexElement(temporal, 'ItemCode', item.ItemCode)
                    const index2 = getIndexElement(customer, 'CustomerNo', item.CustomerNo)
                    const splitDate = item.InvoiceDate ? item.InvoiceDate.split('-') : []
                    if (index === -1 && splitDate.length === 3) {

                        const json = {
                            ItemCode: item.ItemCode,
                            ItemCodeDesc: item.ItemCodeDesc,
                            ProductLine: item.ProductLineDesc,
                            Detail: []
                        }

                        const year = {
                            year: String(splitDate[0]),
                            Months: []
                        }

                        const month = {
                            month: String(splitDate[1]),
                            dolar: '$',
                            shorts: item.shorts,
                            QuantityShipped: Number(item.QuantityShipped),
                            PurchaseCost: item.UnitCost,
                        }
                        year.Months.push(month)
                        json.Detail.push(year)
                        temporal.push(json)
                    } else if (splitDate.length === 3) {
                        const element = temporal[index]
                        const indexYear = getIndexElement(element.Detail, 'year', String(splitDate[0]))
                        if (indexYear === -1) {
                            const year2 = {
                                year: String(splitDate[0]),
                                Months: []
                            }

                            const month2 = {
                                month: String(splitDate[1]),
                                dolar: '$',
                                shorts: item.shorts,
                                QuantityShipped: Number(item.QuantityShipped),
                                PurchaseCost: item.UnitCost,
                            }
                            year2.Months.push(month2)
                            element.Detail.push(year2)
                        } else {
                            const element2 = element.Detail[indexYear]
                            const indexMonth = getIndexElement(element2.Months, 'month', String(splitDate[1]))
                            if (indexMonth === -1) {
                                const month3 = {
                                    month: String(splitDate[1]),
                                    dolar: '$',
                                    shorts: item.shorts,
                                    QuantityShipped: Number(item.QuantityShipped),
                                    PurchaseCost: item.UnitCost,
                                }
                                element2.Months.push(month3)
                                element.Detail[indexYear] = element2
                                temporal[index] = element

                            } else {
                                //AÑADIR PROMEDIOS Y SUMAS
                                const element3 = element2.Months[indexMonth]
                                element3.shorts += item.shorts
                                element3.QuantityShipped += item.QuantityShipped
                                element3.PurchaseCost += item.UnitCost
                                element2.Months[indexMonth] = element3
                                element.Detail[indexYear] = element2
                                temporal[index] = element
                            }
                        }

                    }

                    if (index2 === -1 && splitDate.length === 3) {

                        const json = {
                            CustomerNo: item.CustomerNo,
                            CustomerName: item.BillToName,
                            AddressLine1: item.AddressLine1,
                            City: item.City,
                            State: item.State,
                            ZipCode: item.ZipCode,
                            Detail: []
                        }

                        const year = {
                            year: String(splitDate[0]),
                            Months: []
                        }

                        const month = {
                            month: String(splitDate[1]),
                            dolar: '$',
                            shorts: item.shorts,
                            QuantityShipped: Number(item.QuantityShipped),
                            PurchaseCost: item.UnitCost,
                        }
                        year.Months.push(month)
                        json.Detail.push(year)
                        customer.push(json)
                    } else if (splitDate.length === 3) {
                        const element = customer[index2]
                        const indexYear = getIndexElement(element.Detail, 'year', String(splitDate[0]))
                        if (indexYear === -1) {
                            const year2 = {
                                year: String(splitDate[0]),
                                Months: []
                            }

                            const month2 = {
                                month: String(splitDate[1]),
                                dolar: '$',
                                shorts: item.shorts,
                                QuantityShipped: Number(item.QuantityShipped),
                                PurchaseCost: item.UnitCost,
                            }
                            year2.Months.push(month2)
                            element.Detail.push(year2)
                        } else {
                            const element2 = element.Detail[indexYear]
                            const indexMonth = getIndexElement(element2.Months, 'month', String(splitDate[1]))
                            if (indexMonth === -1) {
                                const month3 = {
                                    month: String(splitDate[1]),
                                    dolar: '$',
                                    shorts: item.shorts,
                                    QuantityShipped: Number(item.QuantityShipped),
                                    PurchaseCost: item.UnitCost,
                                }
                                element2.Months.push(month3)
                                element.Detail[indexYear] = element2
                                customer[index2] = element

                            } else {
                                //AÑADIR PROMEDIOS Y SUMAS
                                const element3 = element2.Months[indexMonth]
                                element3.shorts += item.shorts
                                element3.QuantityShipped += item.QuantityShipped
                                element3.PurchaseCost += item.UnitCost
                                element2.Months[indexMonth] = element3
                                element.Detail[indexYear] = element2
                                customer[index2] = element
                            }
                        }

                    }
                }

                for (const month of this.state.HeaderTable.Row2) {
                    for (const item of temporal) {
                        const indexyear = getIndexElement(item.Detail, 'year', month.year)
                        if (indexyear === -1) {
                            const add = {
                                year: month.year,
                                Months: [{
                                    PurchaseCost: '-',
                                    QuantityShipped: 0.00,
                                    dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }]
                            }
                            item.Detail.push(add)
                        } else {
                            const temporal = item.Detail[indexyear]
                            const indexmonth = getIndexElement(temporal.Months, 'month', String(month.num).length === 1 ? "0" + String(month.num) : String(month.num))
                            if (indexmonth === -1) {
                                const add2 = {
                                    PurchaseCost: '-',
                                    QuantityShipped: 0.00,
                                    dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }
                                temporal.Months.push(add2)
                                item.Detail[indexyear] = temporal
                            }
                        }
                    }

                    for (const item of customer) {
                        const indexyear = getIndexElement(item.Detail, 'year', month.year)
                        if (indexyear === -1) {
                            const add = {
                                year: month.year,
                                Months: [{
                                    PurchaseCost: '-',
                                    QuantityShipped: 0.00,
                                    dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }]
                            }
                            item.Detail.push(add)
                        } else {
                            const temporal = item.Detail[indexyear]
                            const indexmonth = getIndexElement(temporal.Months, 'month', String(month.num).length === 1 ? "0" + String(month.num) : String(month.num))
                            if (indexmonth === -1) {
                                const add2 = {
                                    PurchaseCost: '-',
                                    QuantityShipped: 0.00,
                                    dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }
                                temporal.Months.push(add2)
                                item.Detail[indexyear] = temporal
                            }
                        }
                    }

                }

                temporal = this.Order(temporal, 'ItemCode', true)
                customer = this.Order(customer, 'CustomerNo', true)
                const customers = this.state.CustomerList;

                customer = customer.map(item => {
                const customer = customers.find(c => c.CustomerNo === item.CustomerNo);
                if (customer) {
                    return {
                        ...item,
                        Address: customer.AddressLine1 || '',
                        City: customer.City || '',
                        State: customer.State || '',
                        ZipCode: customer.ZipCode || ''
                    };
                }
                return item;
            });


                temporal = await ItemDesc(temporal, 'ItemCodeDesc', 'ItemCode')
                for (const item of temporal) {
                    for (const detail of item.Detail) {
                        detail.Months = this.Order(detail.Months, 'month', true)
                    }
                    item.Detail = this.Order(item.Detail, 'year', true)
                }
                for (const item of customer) {
                    for (const detail of item.Detail) {
                        detail.Months = this.Order(detail.Months, 'month', true)
                    }
                    item.Detail = this.Order(item.Detail, 'year', true)
                }
                await this.setState({ BodyCustomer: customer, BodyFilterCustomer: customer, Body: temporal, BodyFilter: temporal, Totals: this.getTotals(temporal), AllNoProccessInformation: result.data })
            }
        } else {
            confirmCloseAlert('incorrect', 'Both dates must be established\n to make the report!')
        }
        this.ModalLoading.current.showState(false);
    }

    contains(parametro, busqueda) {
        return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
    }

    searchShorts = e => {

        let search = e.target.value;

        let orders = this.state.Body.filter((item) => {
            if (((
                this.contains(item.ItemCode, search) ||
                this.contains(item.ProductLine, search) ||
                this.contains(item.ItemCodeDesc, search)

            ))
            ) {
                return item
            } else {
                return null
            }
        });
        this.setState({ BodyFilter: orders, Totals: this.getTotals(orders) });

    }

    searchShorts2 = e => {

        let search = e.target.value;

        let orders = this.state.BodyCustomer.filter((item) => {
            if (((
                this.contains(item.CustomerNo, search) ||
                this.contains(item.CustomerName, search)

            ))
            ) {
                return item
            } else {
                return null
            }
        });
        this.setState({ BodyFilterCustomer: orders, Totals: this.getTotals(orders) });

    }

    getTotals(temporal) {
        let totals = []
        let flag = true
        let count = 0
        for (const item of temporal) {
            for (const detail of item.Detail) {
                for (let a = 0; a < detail.Months.length; a++) {
                    if (flag) {
                        totals.push(detail.Months[a].QuantityShipped === '-' ? 0 : Number(detail.Months[a].QuantityShipped))
                        totals.push('$')
                        totals.push(detail.Months[a].shorts === '-' ? 0 : Number(detail.Months[a].shorts))
                    } else {
                        totals[count] += detail.Months[a].QuantityShipped === '-' ? 0 : Number(detail.Months[a].QuantityShipped)
                        count += 2
                        totals[count] += detail.Months[a].shorts === '-' ? 0 : Number(detail.Months[a].shorts)
                        count += 1
                    }

                }
            }
            flag = false
            count = 0
        }
        for (let num = 0; num < totals.length; num++) {
            if (totals[num] !== '$') {
                totals[num] = NumberFormat(pricesFormat(totals[num]))
            }
        }

        return totals
    }

    Order(arreglo, llave, bandera) {

        const l = arreglo.length;
        if (bandera) {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if (arreglo[j][llave] > arreglo[j + 1][llave]) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        } else {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if (arreglo[j][llave] < arreglo[j + 1][llave]) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        }
        return arreglo;
    }

    handleModalOpen = (modal) => {
        var temporal = this.state[modal]
        temporal = true
        this.setState({ [modal]: temporal })
    }

    handleModalClose = (modal) => {
        var temporal = this.state[modal]
        temporal = false
        this.setState({ [modal]: temporal })
    }

    clearOnlyShortDetail() {
        this.setState({
            currentItem: {
                ItemCode: '',
                ItemCodeDesc: '',
                ProductLine: '',
                itemURL: '',
                totalShorts: 0,
                totalQuantityShipped: 0,
                totalQuantityOrdered: 0,
                totalShort: 0
            },
            ShortDetail: [],
            currentCustomer: {
                CustomerNo: '',
                CustomerName: '',
                totalShorts: 0,
                totalQuantityShipped: 0,
                totalQuantityOrdered: 0,
                totalShort: 0
            },
            CustomerDetail: [],
        })
    }

    async DetailofShort(itemCode) {
        this.clearOnlyShortDetail()
        const temporal = this.state.currentItem
        temporal.ItemCode = itemCode.ItemCode
        temporal.ItemCodeDesc = itemCode.ItemCodeDesc
        temporal.ProductLine = itemCode.ProductLine

        let SpecificDetail = []
        var total = 0
        var totalShipped = 0
        var totalOrdered = 0

        for (const item of this.state.AllNoProccessInformation) {
            if (item.ItemCode === itemCode.ItemCode) {
                total += item.shorts
                totalShipped += item.QuantityShipped
                totalOrdered += item.QuantityOrdered
                item.TotalShort = item.shorts
                item.UnitCostD = '$' + pricesFormat(item.UnitCost)
                item.UnitPriceD = '$' + pricesFormat(item.UnitPrice)
                item.TotalShortD = '$' + pricesFormat(item.shorts)
                SpecificDetail.push(item)
            }

        }
        temporal.totalShorts = total
        temporal.totalQuantityShipped = totalShipped
        temporal.totalQuantityOrdered = totalOrdered
        SpecificDetail.push()

        SpecificDetail = OrderArrayByDateGenericLines(SpecificDetail, 'InvoiceDate')
        const data = {
            idCompany: Number(getValueCookie('CompanyId')),
            ItemCode: itemCode.ItemCode
        }
        const resultImg = await getInformationWithData('/Items/get/Img', data)

        if (resultImg.status.code === 1) {
            if (resultImg.data.itemURLImage !== undefined) {
                if (resultImg.data.itemURLImage !== '') {
                    const date = new Date().getTime()
                    temporal.itemURL = `${resultImg.data.itemURLImage}?${date}`
                } else {
                    temporal.itemURL = ''
                }
            } else {
                temporal.itemURL = ''
            }
        }

        await this.setState({ ShortDetail: SpecificDetail, currentItem: temporal })
        var totalRow = {
            InvoiceDate: 'TOTAL',
            QuantityShipped: totalShipped,
            QuantityOrdered: totalOrdered,
            TotalShortD: '$' + pricesFormat(total)
        }
        var copySpecificDetail = JSON.parse(JSON.stringify(SpecificDetail))
        copySpecificDetail.push(totalRow)
        await this.setState({ ShortDetailWithTotal: copySpecificDetail })
        await this.handleModalOpen('showModal1')
    }

    async DetailbyCustomer(info) {
        this.clearOnlyShortDetail()
        const temporal = this.state.currentCustomer
        temporal.CustomerNo = info.CustomerNo
        temporal.CustomerName = info.CustomerName

        let SpecificDetail = []
        var total = 0
        var totalShipped = 0
        var totalOrdered = 0

        for (const item of this.state.AllNoProccessInformation) {
            if (item.CustomerNo === info.CustomerNo) {
                total += item.shorts
                totalShipped += item.QuantityShipped
                totalOrdered += item.QuantityOrdered
                item.TotalShort = item.shorts
                item.UnitCostD = '$' + pricesFormat(item.UnitCost)
                item.UnitPriceD = '$' + pricesFormat(item.UnitPrice)
                item.TotalShortD = '$' + pricesFormat(item.shorts)
                SpecificDetail.push(item)
            }

        }
        temporal.totalShorts = total
        temporal.totalQuantityShipped = totalShipped
        temporal.totalQuantityOrdered = totalOrdered
        SpecificDetail.push()

        SpecificDetail = OrderArrayByDateGenericLines(SpecificDetail, 'InvoiceDate')

        await this.setState({ CustomerDetail: SpecificDetail, currentCustomer: temporal })
        var totalRow = {
            InvoiceDate: 'TOTAL',
            QuantityShipped: totalShipped,
            QuantityOrdered: totalOrdered,
            TotalShortD: '$' + pricesFormat(total)
        }
        var copySpecificDetail = JSON.parse(JSON.stringify(SpecificDetail))
        copySpecificDetail.push(totalRow)
        await this.setState({ ShortDetailWithTotal: copySpecificDetail })
        await this.handleModalOpen('showModal1')
    }

    async OrderPriceMargins(option, pos) {
        var temporal = this.state.BodyFilter
        switch (option) {
            case "Item Code":
                temporal = OrderArray(temporal, "ItemCode", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "Product Line":
                temporal = OrderArray(temporal, "ProductLine", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "Sales":
                let t1 = await this.orderShorts(temporal, pos, "QuantityShipped")
                await this.setState({ BodyFilter: t1, flag: !this.state.flag })
                break;
            case "Sales ($)":
                let t2 = await this.orderShorts(temporal, pos, "shorts")
                await this.setState({ BodyFilter: t2, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }

    async OrderPriceMargins2(option, pos) {
        var temporal = this.state.BodyFilterCustomer
        switch (option) {
            case "Customer No":
                temporal = OrderArray(temporal, "CustomerNo", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Customer Name":
                temporal = OrderArray(temporal, "CustomerName", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Address":
                temporal = OrderArray(temporal, "AddressLine1", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "City":
                temporal = OrderArray(temporal, "City", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "State":
                temporal = OrderArray(temporal, "State", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Zip Code":
                temporal = OrderArray(temporal, "ZipCode", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Sales":
                let t1 = await this.orderShorts(temporal, pos, "QuantityShipped")
                await this.setState({ BodyFilterCustomer: t1, flag: !this.state.flag })
                break;
            case "Sales ($)":
                let t2 = await this.orderShorts(temporal, pos, "shorts")
                await this.setState({ BodyFilterCustomer: t2, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }

    async orderShorts(array, conditions, key) {

        const l = array.length

        for (let i = 0; i < l; i++) {
            for (let j = 0; j < l - 1 - i; j++) {

                const pos1 = await getIndexElement(array[j].Detail, 'year', conditions.year)
                const pos2 = await getIndexElement(array[j].Detail[pos1].Months, 'month', conditions.month)
                const pos3 = await getIndexElement(array[j + 1].Detail, 'year', conditions.year)
                const pos4 = await getIndexElement(array[j + 1].Detail[pos3].Months, 'month', conditions.month)
                const m = array[j].Detail[pos1].Months[pos2][key] === '-' ? 0 : Number(array[j].Detail[pos1].Months[pos2][key])
                const n = array[j + 1].Detail[pos3].Months[pos4][key] === '-' ? 0 : Number(array[j + 1].Detail[pos3].Months[pos4][key])
                if (this.state.flag) {
                    if (m > n) {
                        [array[j], array[j + 1]] = await [array[j + 1], array[j]];
                    }
                } else {
                    if (m < n) {
                        [array[j], array[j + 1]] = await [array[j + 1], array[j]];
                    }
                }

            }
        }

        return array
    }

    valueRadioButton = async e => {
        let stat = Number(e.target.value)
        this.setState({ Mode: stat })
        if (stat === 1) {
            this.setState({Totals: this.getTotals(this.state.BodyFilter)})
        } else {
            this.setState({Totals: this.getTotals(this.state.BodyFilterCustomer)})
        }
    }

    // ── New functions ──────────────────────────────────────────────────────────

    setActiveTab = (tab) => {
        this.setState({ activeTab: tab });
    }

    getCommissionKPIs() {
        const { cashReceipts, allTotals, sellerList } = this.state;
        if (!cashReceipts || cashReceipts.length === 0) return null;
        const totalAmount = cashReceipts.reduce((s, r) => s + Number(r.CashAmountApplied || 0), 0);
        const totalReceipts = cashReceipts.length;
        const qualifiedItems = allTotals.totalQualifiedItems || 0;
        const salespeople = sellerList.length;
        return { totalAmount, totalReceipts, qualifiedItems, salespeople };
    }

    renderTotalsTab = () => {
        const { allTotals, sellerList } = this.state;
        const sectionLabel = { color: '#64748B', fontWeight: 700, fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.75rem' };
        return (
            <div>
                <p style={sectionLabel}>Overall Summary</p>
                <div className="tableFixHeadSmall mb-4" style={{ maxWidth: 420 }}>
                    <table className="table table-clean mb-0">
                        <thead>
                            <tr>
                                <th>Metric</th>
                                <th className="text-end">Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td style={{ fontWeight: 600 }}>Total Amount</td><td className="text-end">${allTotals.totalAmount}</td></tr>
                            <tr><td style={{ fontWeight: 600 }}>Total Invoices</td><td className="text-end">{allTotals.totalInvoices}</td></tr>
                            <tr><td style={{ fontWeight: 600 }}>Commission Items</td><td className="text-end">{allTotals.totalQualifiedItems}</td></tr>
                        </tbody>
                    </table>
                </div>
                <p style={sectionLabel}>Sales by Salesperson</p>
                <div className="tableFixHeadSmall">
                    <table className="table table-clean mb-0">
                        <thead>
                            <tr>
                                <th>Seller</th>
                                <th>Salesperson No</th>
                                <th className="text-end">Total Amount</th>
                                <th className="text-end">Total Invoices</th>
                                <th className="text-end">Commission Items</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sellerList.map((person) => (
                                <tr key={person.SalespersonNo}>
                                    <td style={{ fontWeight: 600, color: '#334155' }}>{person.SalespersonName}</td>
                                    <td>
                                        <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{person.SalespersonNo}</span>
                                    </td>
                                    <td className="text-end" style={{ fontWeight: 700 }}>${pricesFormat(person.CashAmountApplied)}</td>
                                    <td className="text-end">{person.count}</td>
                                    <td className="text-end">{person.CommissionTotal}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    renderSalespersonTab = (seller) => {
        const sectionLabel = { color: '#64748B', fontWeight: 700, fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.75rem' };
        return (
            <div key={seller.SalespersonNo}>
                <div className="row g-3 mb-4">
                    <div className="col-sm-12 col-md-4">
                        <div className="metric-card status-primary">
                            <div className="metric-label">Total Amount</div>
                            <div className="metric-value">${seller.CashAmountApplied.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                            <div className="metric-change">Cash applied</div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <div className="metric-card status-success">
                            <div className="metric-label">Total Invoices</div>
                            <div className="metric-value">{seller.count}</div>
                            <div className="metric-change">Processed this week</div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <div className="metric-card status-warning">
                            <div className="metric-label">Commission Items</div>
                            <div className="metric-value">{seller.CommissionTotal}</div>
                            <div className="metric-change">Qualified items</div>
                        </div>
                    </div>
                </div>
                <p style={sectionLabel}>Orders Detail — {seller.SalespersonName}</p>
                <div className="tableFixHeadSmall">
                    <table className="table table-clean mb-0">
                        <thead>
                            <tr>
                                <th>Invoice No</th>
                                <th>Date</th>
                                <th>Customer</th>
                                <th className="text-end">Amount</th>
                                <th className="text-center">Commission Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.cashReceipts.map((receipt, i) => (
                                seller.SalespersonNo === receipt.SalespersonNo
                                    ? <tr key={i}>
                                        <td>{receipt.InvoiceNo}</td>
                                        <td>{receipt.DepositDate}</td>
                                        <td>{receipt.CustomerName}</td>
                                        <td className="text-end">${receipt.CashAmountApplied}</td>
                                        <td className="text-center">{receipt.CommissionTotal}</td>
                                    </tr>
                                    : null
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    handleFetchData = async () => {
        this.setState({ loading: true });

        const { year, week } = this.state;
        const { start, end } = this.getWeekRange();
        this.ModalLoading.current.showState(true);

        // Format dates for Sage MAS90
        const startDate = start.toISOString().split('T')[0];
        const endDate = end.toISOString().split('T')[0];
        const IdCompany = getValueCookie('CompanyId')

        console.log('Fetching data from Sage MAS90:', { startDate, endDate, year, week });

        try {
        // Simulate API call - Replace with your actual API endpoint
        // const response = await fetch('/api/sage-reports', {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({ startDate, endDate })
        // });
        // const data = await response.json();

        // Simulate API response with sample data
        await new Promise(resolve => setTimeout(resolve, 1500));

        const mockData = {
            totals: {
            totalSales: 125430.50,
            totalOrders: 87,
            avgOrderValue: 1441.50
            },
            salespeople: [
            {
                id: 1,
                name: 'John Smith',
                sales: 45230.25,
                orders: 32,
                avgOrder: 1413.44
            },
            {
                id: 2,
                name: 'Maria Garcia',
                sales: 38950.00,
                orders: 28,
                avgOrder: 1391.07
            },
            {
                id: 3,
                name: 'Robert Johnson',
                sales: 41250.25,
                orders: 27,
                avgOrder: 1527.79
            }
            ]
        };

        this.setState({
            reportData: mockData,
            activeTab: 'totals',
            loading: false
        });

        } catch (error) {
        console.error('Error fetching data:', error);
        alert('Error loading data. Please try again.');
        this.setState({ loading: false });
        }

        // API REQUEST

        const url = 'https://backv2.portalmanager.pro'

        const payload = {
            data: {
                start: startDate,
                end: endDate,
                IdCompany
            }
        }

        const query = "/invoices/cash-receipts";
        const cashReceipts = await axios.post(`${url}${query}`, payload).then(
            response =>  response.data.data
        ).catch(error => {
            console.log(error)
        })
        this.setState({cashReceipts})
        this.checkQualifiedItem()
    }

    getUniqueAndAccumulate(array, uniqueKeys, accumulateKeys) {
        const map = new Map();

        for (const obj of array) {
            const key = uniqueKeys.map(k => obj[k]).join('|');

            if (!map.has(key)) {
            // First time seeing this combination - store the object and set count to 1
            map.set(key, { ...obj, count: 1 });
            } else {
            // Already exists - accumulate the total and increment count
            const existing = map.get(key);
            for(const i of accumulateKeys){
                existing[i] = (existing[i] || 0) + (obj[i] || 0);
            }
            existing.count += 1;
            }
        }

        return Array.from(map.values());
    }

    getDateFromWeek = (year, week) => {
        const jan4 = new Date(year, 0, 4);
        const dayNum = jan4.getDay() || 7;
        jan4.setDate(jan4.getDate() - dayNum + 1);
        const weekStart = new Date(jan4);
        weekStart.setDate(weekStart.getDate() + (week - 1) * 7);
        return weekStart
    }

    formatDate = (date) => {
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric'
        });
    }

    // Get week date range
    getWeekRange = () => {
        const { year, week } = this.state;
        const start = this.getDateFromWeek(year, week);
        const end = new Date(start);
        end.setDate(end.getDate() + 6);
        return { start, end };
    }

    // Verify if an item is legible for commission
    // TODO: Update endpoint for AR_details mirror with mas90 and Remove the code related with catalog
    async checkQualifiedItem(){
        const { cashReceipts } = this.state
        const getInvoiceList = cashReceipts.map(i => i.InvoiceNo)
        const invoiceItems = await this.getWeekInvoicesDetail(getInvoiceList)

        // Validate each items if is qualified for commission

        const result = invoiceItems.map(obj => {
            // Check if exists AND price is equal or higher
            const isQualified = obj.UnitPrice >= obj.UnitCost;

            return {
                ...obj,
                commission: isQualified,
            }
        });

        const qualifiedOnly = result.filter(item => item.commission === true);

        // Add commission info
        // Step 1: Group qualifiedOnly by InvoiceNo (do this ONCE)
        const commissionByInvoice = qualifiedOnly.reduce((acc, item) => {
            if (!acc[item.InvoiceNo]) {
                acc[item.InvoiceNo] = 0;
            }
            acc[item.InvoiceNo] += item.commission;
            return acc;
        }, {});

        // Step 2: Add to receipts list (fast lookup with Map)
        const updateReceiptsWCounters = cashReceipts.map(r => ({
            ...r,
            CommissionTotal: commissionByInvoice[r.InvoiceNo] || 0
        }));

        // Get the seller salesperson list
        const sellerList = this.getUniqueAndAccumulate(updateReceiptsWCounters, ['SalespersonNo', 'SalespersonName'], ['CashAmountApplied', 'CommissionTotal'],);

        // Update totals
        const totalInvoices = qualifiedOnly.length
        const totalAmount = pricesFormat(qualifiedOnly.reduce((acc, invoice) => acc + Number(invoice.Total), 0))
        const totalQualifiedItems = qualifiedOnly.reduce((acc, item) => acc + Number(item.QuantityShipped), 0)

        const allTotals = {totalInvoices, totalAmount, totalQualifiedItems}

        this.setState({qualifiedItems: qualifiedOnly, cashReceipts: updateReceiptsWCounters, sellerList, allInvoiceItems: result, allTotals})
        this.ModalLoading.current.showState(false);
        this.setState({ loading: false });
    }

    async getWeekInvoicesDetail(InvoiceList){
        const url = 'https://backv2.portalmanager.pro'

        const payload = {
            data: {
                InvoiceList
            }
        }

        const query = "/v2/invoice/history/detail";
        const InvoiceItems = await axios.post(`${url}${query}`, payload).then(
            response =>  response.data.data
        ).catch(error => {
            console.log(error)
        })

        this.setState({ InvoiceItems });
        return InvoiceItems;
    }

    handleYearChange = (e) => {
        this.setState({ year: parseInt(e.target.value)})
    }

    handleWeekChange = (e) => {
        this.setState({ week: parseInt(e.target.value)})
    }

    render() {
        const { year, week, loading, reportData, activeTab, cashReceipts, sellerList } = this.state;
        const { start, end } = this.getWeekRange();
        const weeksInYear = 52;
        const hasData = !!(reportData && cashReceipts && cashReceipts.length > 0);
        const kpis = hasData ? this.getCommissionKPIs() : null;

        const labelStyle = { fontSize: '0.72rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: '5px' };
        const selectStyle = { borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.875rem', padding: '0.4rem 0.75rem', width: '100%' };

        return (
            <div className="dash-page" style={{ }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{ marginTop: 30, background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '2rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <AiOutlineBarChart style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Commission Report</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>Weekly commission analysis by salesperson</p>
                    </div>
                    {hasData && (
                        <div style={{ marginLeft: 'auto' }}>
                            <span style={{ background: 'rgba(255,255,255,0.15)', color: 'white', borderRadius: '999px', padding: '0.3rem 1rem', fontSize: '0.8rem', fontWeight: 700 }}>
                                Week {week} · {this.formatDate(start)} – {this.formatDate(end)}, {year}
                            </span>
                        </div>
                    )}
                </div>

                <div style={{ padding: '1.5rem 2rem' }}>

                    {/* Controls */}
                    <div className="card mb-3" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                            <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Period Selection</span>
                        </div>
                        <div className="card-body">
                            <div className="row g-3 align-items-end">
                                <div className="col-sm-12 col-md-3">
                                    <label style={labelStyle} htmlFor="yearCommission">Year</label>
                                    <select style={selectStyle} id="yearCommission" value={year} onChange={this.handleYearChange} disabled={loading}>
                                        {[2022, 2024, 2025, 2026].map(y => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <label style={labelStyle} htmlFor="weekCommission">Week</label>
                                    <select style={selectStyle} id="weekCommission" value={week} onChange={this.handleWeekChange} disabled={loading}>
                                        {Array.from({ length: weeksInYear }, (_, i) => i + 1).map(w => (
                                            <option key={w} value={w}>Week {w}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <label style={labelStyle}>Selected Range</label>
                                    <div style={{ fontWeight: 700, color: '#334155', fontSize: '0.875rem', padding: '0.4rem 0' }}>
                                        Week {week} · {this.formatDate(start)} – {this.formatDate(end)}, {year}
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-3 d-flex gap-2 align-items-center justify-content-end">
                                    <button disabled={loading} onClick={() => this.handleFetchData()} style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', border: 'none', borderRadius: '8px', padding: '0.45rem 1.25rem', fontWeight: 700, fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem', opacity: loading ? 0.7 : 1 }}>
                                        <AiOutlineReload /> Load Data
                                    </button>
                                    {hasData && (
                                        <ExcelDocument
                                            archname={'Commission Report Week: ' + this.formatDate(start) + ' ' + this.formatDate(end) + ' ' + year}
                                            sheetname={'Invoices'}
                                            sheetname2={['Items']}
                                            data={getDataSet(this.state.cashReceipts,
                                                ['Invoice No', 'Receipt Date', 'Customer No', 'Customer Name', 'SalesPerson', 'Seller Name', 'Invoice Total', 'Total Commission Items'],
                                                ['InvoiceNo', 'DepositDate', 'CustomerNo', 'CustomerName', 'SalespersonNo', 'SalespersonName', 'CashAmountApplied', 'CommissionTotal']
                                            )}
                                            data2={[getDataSet(this.state.allInvoiceItems,
                                                ['Invoice No', 'Item Code', 'Unit Cost', 'Unit Price', 'Quantity Ordered', 'Quantity Shipped', 'Total', 'Total Commission Items'],
                                                ['InvoiceNo', 'ItemCode', 'UnitCost', 'UnitPrice', 'QuantityOrdered', 'QuantityShipped', 'Total', 'QuantityShipped']
                                            )]}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* KPIs */}
                    {hasData && kpis && (
                        <div className="row g-3 mb-3">
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-primary">
                                    <div className="metric-label">Cash Receipts</div>
                                    <div className="metric-value">{kpis.totalReceipts.toLocaleString('en-US')}</div>
                                    <div className="metric-change">Invoices processed</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-success">
                                    <div className="metric-label">Total Amount</div>
                                    <div className="metric-value">${kpis.totalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                    <div className="metric-change">Applied this week</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-warning">
                                    <div className="metric-label">Commission Items</div>
                                    <div className="metric-value">{kpis.qualifiedItems.toLocaleString('en-US')}</div>
                                    <div className="metric-change">Qualified for commission</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="metric-card status-primary">
                                    <div className="metric-label">Salespeople</div>
                                    <div className="metric-value">{kpis.salespeople.toLocaleString('en-US')}</div>
                                    <div className="metric-change">Active this week</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Commission tabs */}
                    {hasData && (
                        <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', gap: '0.4rem', flexWrap: 'wrap', alignItems: 'center' }}>
                                {[{ key: 'totals', label: 'Totals' }, ...sellerList.map(s => ({ key: `seller-${s.SalespersonNo}`, label: s.SalespersonName }))].map(t => (
                                    <button key={t.key} onClick={() => this.setActiveTab(t.key)}
                                        style={{ padding: '0.3rem 0.875rem', borderRadius: '6px', fontWeight: 700, fontSize: '0.8rem', cursor: 'pointer', border: 'none', background: activeTab === t.key ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.1)', color: 'white' }}>
                                        {t.label}
                                    </button>
                                ))}
                            </div>
                            <div className="card-body">
                                {activeTab === 'totals' && this.renderTotalsTab()}
                                {sellerList.map((seller) => (
                                    activeTab === `seller-${seller.SalespersonNo}` && this.renderSalespersonTab(seller)
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Empty state */}
                    {!hasData && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <AiOutlineBarChart style={{ fontSize: '3rem', opacity: 0.3, marginBottom: '1rem' }} />
                            <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>Select a <strong>year</strong> and <strong>week</strong>, then click <strong>Load Data</strong> to view the commission report.</p>
                        </div>
                    )}

                </div>{/* end padding content */}

                <ModalOrders title={this.state.Mode === 1 ? 'Sales of Item: ' + this.state.currentItem.ItemCode : 'Sales of Customer: ' + this.state.currentCustomer.CustomerName} show={this.state.showModal1} close={(modal = "showModal1") => this.handleModalClose(modal)}>

                    {
                        this.state.Mode === 1 ?
                            <div className='col-12'>
                                <div className='row d-flex justify-content-center'>
                                    <div className='col-sm-6 col-lg-6'>
                                        <div className='row'>
                                            <div className='col-12 pt-2 text-center d-lg-flex justify-content-lg-end d-sm-block text-sm-center align-items-center'>
                                                <div className='ItemImg'>
                                                    <img key={this.state.currentItem.itemURL} className='pb-5 pt-5' id='ShortsProductImg' src={this.state.currentItem.itemURL !== '' ? this.state.currentItem.itemURL : '/assets/notavailable.png'} alt='ProductImg' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-sm-6 col-lg-6'>
                                        <div className='row pt-5'>
                                            <div className='col-12 TitleText mt-4 mb-2'>
                                                <span className='badge bg-primary me-4'>{this.state.currentItem.ItemCode}</span>
                                                <span className='badge bg-secondary'>{this.state.currentItem.ProductLine}</span>
                                            </div>
                                            <div className='col-12 TitleText'>
                                                <p>{this.state.currentItem.ItemCodeDesc}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-lg-4 py-4">
                                        <ExcelDocument archname={'Sales Item ' + DeleteCharactersNotAccepted(this.state.currentItem.ItemCode) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')} sheetname={'Shorts Item ' + DeleteCharactersNotAccepted(this.state.currentItem.ItemCode) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')} data={getDataSet(this.state.ShortDetailWithTotal, ['Sales Order No', 'Invoice No', 'Customer No', 'Customer Name', 'Price Level', 'Sales Person', 'Route', 'Date', 'Quantity Ordered', 'Quantity Shipped', 'Unit Cost', 'Total Sales($)'], ['SalesOrderNo', 'InvoiceNo', 'CustomerNo', 'BillToName', 'PriceLevel', 'SalespersonNo', 'UDF_RUTA', 'InvoiceDate', 'QuantityOrdered', 'QuantityShipped', 'UnitPriceD', 'TotalShortD'])} />
                                    </div>
                                </div>
                                <div className='row pt-2'>
                                    <div className='col-12 tableFixHeadSmall'>
                                        <table className='table table-clean mb-0'>
                                            <thead>
                                                <tr className='text-center'>
                                                    <th>SO No</th><th>Invoice No</th><th>Type</th>
                                                    <th>Customer No</th><th>Customer Name</th><th>Price Level</th>
                                                    <th>Salesperson</th><th>Route</th><th>Date</th>
                                                    <th>Qty Ordered</th><th>Qty Shipped</th>
                                                    <th></th><th>Unit Price</th><th></th><th>Total Sales($)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.ShortDetail.map((item, i) => (
                                                        <tr key={i}>
                                                            <td className='text-center'>{item.SalesOrderNo}</td>
                                                            <td className='text-center'>{item.InvoiceNo}</td>
                                                            <td className='text-center'>{item.InvoiceType}</td>
                                                            <td className='text-center'>{item.CustomerNo}</td>
                                                            <td className='text-start'>{item.BillToName}</td>
                                                            <td className='text-center'>{item.PriceLevel}</td>
                                                            <td className='text-center'>{item.SalespersonNo}</td>
                                                            <td className='text-start'>{item.UDF_RUTA}</td>
                                                            <td className='text-center'>{DateFormatMAS90(item.InvoiceDate)}</td>
                                                            <td className='text-center'>{NumberFormat(item.QuantityOrdered)}</td>
                                                            <td className='text-center'>{NumberFormat(item.QuantityShipped)}</td>
                                                            <td className='text-end'>{'$'}</td>
                                                            <td className='text-end'>{NumberFormat(pricesFormat(item.UnitPrice))}</td>
                                                            <td className='text-end'>{'$'}</td>
                                                            <td className='text-end'>{NumberFormat(pricesFormat(item.shorts))}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                            <tfoot className='tfoot'>
                                                <tr>
                                                    <td className='text-center'></td>
                                                    <td className='text-center'></td>
                                                    <td className='text-center'></td>
                                                    <td className='text-start'></td>
                                                    <td className='text-center'></td>
                                                    <td className='text-center'></td>
                                                    <td className='text-start'></td>
                                                    <td className='text-center'>{'TOTAL'}</td>
                                                    <td className='text-center'>{NumberFormat(pricesFormat(this.state.currentItem.totalQuantityOrdered))}</td>
                                                    <td className='text-center'>{NumberFormat(pricesFormat(this.state.currentItem.totalQuantityShipped))}</td>
                                                    <td className='text-center'></td>
                                                    <td className='text-end'></td>
                                                    <td className='text-end'>{'$'}</td>
                                                    <td className='text-end'>{NumberFormat(pricesFormat(this.state.currentItem.totalShorts))}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        :
                            <div>
                                <div className='row d-flex justify-content-center'>
                                    <div className='col-12 my-3'>
                                        <div className='row'>
                                            <div className='col-6 titleTotal text-end'>
                                                <p>Customer No:</p>
                                            </div>
                                            <div className='col-6 TitleText'>
                                                <p>{this.state.currentCustomer.CustomerNo}</p>
                                            </div>
                                            <div className='col-6 titleTotal text-end'>
                                                <p>Customer Name: </p>
                                            </div>
                                            <div className='col-6 TitleText'>
                                                <p>{this.state.currentCustomer.CustomerName}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-lg-4 py-4">
                                        <ExcelDocument archname={'Sales Customer ' + DeleteCharactersNotAccepted(this.state.currentCustomer.CustomerName) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')} sheetname={'Sales ' + DeleteCharactersNotAccepted(this.state.currentCustomer.CustomerName)} data={getDataSet(this.state.ShortDetailWithTotal, ['Sales Order No', 'Invoice No', 'Item Code', 'Description', 'Price Level', 'Sales Person', 'Route', 'Date', 'Quantity Ordered', 'Quantity Shipped', 'Unit Cost', 'Total Sales($)'], ['SalesOrderNo', 'InvoiceNo', 'ItemCode', 'ItemCodeDesc', 'PriceLevel', 'SalespersonNo', 'UDF_RUTA', 'InvoiceDate', 'QuantityOrdered', 'QuantityShipped', 'UnitPriceD', 'TotalShortD'])} />
                                    </div>
                                </div>
                                <div className='row pt-2'>
                                    <div className='col-12 tableFixHead'>
                                        <table className='table table-hover'>
                                            <thead className='table-dark'>
                                                <tr className='text-center'>
                                                    <th>Sales Order No</th>
                                                    <th>Invoice No</th>
                                                    <th>Type</th>
                                                    <th>Item Code</th>
                                                    <th>Description</th>
                                                    <th>Price Level</th>
                                                    <th>Sales Person</th>
                                                    <th>Route</th>
                                                    <th>Date</th>
                                                    <th>Quantity Ordered</th>
                                                    <th>Quantity Shipped</th>
                                                    <th></th>
                                                    <th>Unit Price</th>
                                                    <th></th>
                                                    <th>Total Sales($)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.CustomerDetail.map((item, i) => (
                                                        <tr key={i}>
                                                            <td className='text-center'>{item.SalesOrderNo}</td>
                                                            <td className='text-center'>{item.InvoiceNo}</td>
                                                            <td className='text-center'>{item.InvoiceType}</td>
                                                            <td className='text-center'>{item.ItemCode}</td>
                                                            <td className='text-start'>{item.ItemCodeDesc}</td>
                                                            <td className='text-center'>{item.PriceLevel}</td>
                                                            <td className='text-center'>{item.SalespersonNo}</td>
                                                            <td className='text-start'>{item.UDF_RUTA}</td>
                                                            <td className='text-center'>{DateFormatMAS90(item.InvoiceDate)}</td>
                                                            <td className='text-center'>{NumberFormat(item.QuantityOrdered)}</td>
                                                            <td className='text-center'>{NumberFormat(item.QuantityShipped)}</td>
                                                            <td className='text-end'>{'$'}</td>
                                                            <td className='text-end'>{NumberFormat(pricesFormat(item.UnitPrice))}</td>
                                                            <td className='text-end'>{'$'}</td>
                                                            <td className='text-end'>{NumberFormat(pricesFormat(item.shorts))}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                            <tfoot className='tfoot'>
                                                <tr>
                                                    <td className='text-center'></td>
                                                    <td className='text-center'></td>
                                                    <td className='text-center'></td>
                                                    <td className='text-start'></td>
                                                    <td className='text-center'></td>
                                                    <td className='text-center'></td>
                                                    <td className='text-start'></td>
                                                    <td className='text-center'>{'TOTAL'}</td>
                                                    <td className='text-center'>{NumberFormat(pricesFormat(this.state.currentCustomer.totalQuantityOrdered))}</td>
                                                    <td className='text-center'>{NumberFormat(pricesFormat(this.state.currentCustomer.totalQuantityShipped))}</td>
                                                    <td className='text-center'></td>
                                                    <td className='text-end'></td>
                                                    <td className='text-end'>{'$'}</td>
                                                    <td className='text-end'>{NumberFormat(pricesFormat(this.state.currentCustomer.totalShorts))}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                    }

                </ModalOrders>

            </div>
        )
    }

}
